import { Injectable } from "@angular/core";
import {
  AcepSSOService,
  GlobalDomOpsService,
  GlobalDataOpsService,
  CommonOperationsService
} from "@acepteam/globalspack";
import { GroupPortalDomService, GroupPortalDataService } from "../../services";
import {
  DomService,
  DataService,
  HelperService,
  LoggerService
} from "../../../core/services";
import { MyAccountDataOpsService } from "../../services/my-account-dataops.service";
import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
import { map, share } from "rxjs/operators";
import {
  ChapterDetails,
  ChapterInfo
} from "../../../shared/models/chapter-details";
import { ProductSubType } from "../../../shared/enums/xrm.constants";
import { OrderGenProduct } from "../../../shared/models";
import { CustomerAddress } from "../../../shared/models/my-account-data.models";
import { getPrimaryAddress } from "../../helpers/mapper";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class SideNavService {
  setInvalidResidency$ = new Subject<boolean>();
  refreshResidency$ = new Subject<boolean>();

  constructor(
    private globalDataOpsService: GlobalDataOpsService,
  ) { }


}